import React from 'react';
import { Modal, ModalBody, Button } from 'reactstrap';

const UserTelephoneAlert = ({ show, setShow }) => (
  <Modal isOpen={show} toggle={() => setShow(false)} centered>
    <ModalBody className="text-center p-4">
      <i
        className="las la-exclamation-triangle text-warning d-block mb-3"
        style={{ fontSize: 48 }}
      />
      <h5 className="mb-3">Telefone não permitido</h5>
      <p className="text-gray-700 mb-4">
        Identificamos que este número pertence a um usuário Viddy. Não é
        possível criar uma venda para um telefone cadastrado como usuário. Em
        caso de dúvida, entre em contato com o suporte.
      </p>
      <Button color="primary" block onClick={() => setShow(false)}>
        Entendi
      </Button>
    </ModalBody>
  </Modal>
);

export default UserTelephoneAlert;
